import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Tila',
      fields: {
        delivery_visible: {
          label: 'Kotiinkuljetus näkyvissä',
        },
        has_delivery: {
          label: 'Kotiinkuljetus',
        },
        delivery_enabled: {
          label: 'Kotiinkuljetus käytössä',
        },
      },
    },
    delivery_mode: {
      title: 'Kuljetustapa',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Ravintolan omat kuljettajat',
            [DeliveryMode.External]: 'Ulkoiset kuljettajat ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Kuljettajan noutohuomautus',
          placeholder: 'Lisätietoa kuljettajalle noutoa varten (esim. miten löytää sisäänkäynti jne.)',
        },
        instant_print_enabled: {
          label: 'Tulosta tilauskuitti odottamatta kuljettajaa',
        },
        provider_not_connected: {
          wolt_drive: 'Ei vielä yhdistetty: tällä ravintolalla ei ole kelvollista Wolt-toimipaikkatunnusta.',
          connects_on_external:
            '{{provider}} yhdistetään, kun kuljetustavaksi asetetaan ulkoiset kuljettajat ja asetus tallennetaan.',
          not_connected_yet:
            '{{provider}} ei ole vielä yhdistetty tähän ravintolaan. Jos tilanne ei muutu, ota yhteyttä tukeen.',
        },
      },
    },
    scheduled_orders: {
      title: 'Ajastetut tilaukset',
      fields: {
        has_scheduled_orders: {
          label: 'Sallitaanko asiakkaiden tilata etukäteen tietylle ajalle?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Vähimmäisaika (minuuteissa) etukäteen <strong>kotiinkuljetus</strong>tilausten ajastamiseen',
          placeholder: '60',
          validation_name: 'Kotiinkuljetuksen vähimmäisajastusaika',
          external_hint: 'Ulkoisen kuljetuksen kanssa tämän on oltava vähintään {{minutes}} minuuttia (2 tuntia). ',
        },
        last_order_gap_delivery: {
          label:
            'Viimeinen mahdollinen tilausaika <strong>kotiinkuljetukselle</strong> (minuuttia ennen sulkemisaikaa)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Kuljetustiedot',
      fields: {
        average_order_delivery_time_min: {
          label: 'Kuljetusaika',
          placeholder: 'Aika minuuteissa',
        },
        average_order_delivery_time_max: {
          label: 'asti',
          placeholder: 'Valinnainen',
        },
      },
    },
    delivery_zones: {
      title: 'Kuljetusalueet',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    at_least_one_order_method_required:
      'Vähintään yhden tilaustavan (ajastettu tai heti) on oltava käytössä. Et voi poistaa molempia käytöstä.',
  },
};
